(() => {
  const key = 'bynili-favorites-v1';
  let items = [];
  let lastOpener;
  const productCache = new Map();
  const dialog = document.getElementById('ByniliFavorites');
  if (!dialog) return;
  const list = dialog.querySelector('[data-bynili-favorites-list]');
  const empty = dialog.querySelector('[data-bynili-empty]');
  const status = document.querySelector('[data-bynili-favorites-status]');
  const labels = dialog.dataset;
  const safeProductUrl = (value) => {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin && /\/products\//.test(url.pathname) ? url.pathname + url.search : '';
    } catch { return ''; }
  };
  function load() {
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      items = Array.isArray(data) ? data.filter(item => item && typeof item.id === 'string' && typeof item.title === 'string' && safeProductUrl(item.url)).slice(0,200) : [];
    } catch { items = []; }
  }
  function sync(root = document) {
    root.querySelectorAll('[data-bynili-favorite]').forEach(button => {
      const active = items.some(item => item.id === button.dataset.id);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? labels.removeLabel : labels.saveLabel);
    });
    document.querySelectorAll('[data-bynili-count]').forEach(counter => {
      if (counter.textContent !== String(items.length)) counter.textContent = String(items.length);
      counter.hidden = items.length === 0;
    });
  }
  function render() {
    list.replaceChildren();
    empty.hidden = items.length > 0;
    for (const item of items) {
      const card = document.createElement('article');
      card.className = 'bynili-saved-card';
      const link = document.createElement('a');
      link.href = safeProductUrl(item.url);
      if (item.image && /^(https?:)?\/\//.test(item.image)) {
        const image = document.createElement('img');
        image.src = new URL(item.image, location.origin).href;
        image.alt = item.title;
        image.loading = 'lazy';
        image.width = 300;
        image.height = 400;
        link.append(image);
      }
      const title = document.createElement('h3');
      title.textContent = item.title;
      link.append(title);
      const price = document.createElement('p');
      price.className = 'bynili-saved-price';
      price.textContent = item.price || '';
      if (item.price) card.append(price);
      const view = document.createElement('a');
      view.href = safeProductUrl(item.url);
      view.className = 'bynili-saved-view';
      view.textContent = labels.viewLabel;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.byniliRemove = item.id;
      remove.textContent = labels.removeLabel;
      card.prepend(link);
      card.append(view, remove);
      list.append(card);
    }
  }
  async function refreshPrices() {
    await Promise.all(items.map(async item => {
      const url = safeProductUrl(item.url);
      if (!url) return;
      if (!productCache.has(url)) productCache.set(url, fetch(url.split('?')[0] + '.js').then(response => { if (!response.ok) throw new Error(); return response.json(); }).catch(() => null));
      const product = await productCache.get(url);
      if (!product || !items.includes(item)) return;
      item.price = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {style:'currency',currency:window.Shopify?.currency?.active || 'BRL'}).format(product.price / 100);
    }));
    render();
    try { localStorage.setItem(key, JSON.stringify(items)); } catch {}
  }
  function persist() {
    try {
      localStorage.setItem(key, JSON.stringify(items));
      sync();
      render();
    } catch {
      load();
      sync();
      if (status) status.textContent = labels.errorLabel;
    }
  }
  document.addEventListener('click', event => {
    const favorite = event.target.closest('[data-bynili-favorite]');
    const opener = event.target.closest('[data-bynili-open]');
    const remove = event.target.closest('[data-bynili-remove]');
    if (favorite) {
      event.preventDefault();
      const index = items.findIndex(item => item.id === favorite.dataset.id);
      if (index >= 0) items.splice(index, 1);
      else if (safeProductUrl(favorite.dataset.url)) items.push({id:favorite.dataset.id,title:favorite.dataset.title,url:favorite.dataset.url,image:favorite.dataset.image,price:favorite.dataset.price});
      persist();
    } else if (opener) {
      event.preventDefault();
      lastOpener = opener;
      load();
      sync();
      render();
      dialog.showModal();
      refreshPrices();
    } else if (remove) {
      items = items.filter(item => item.id !== remove.dataset.byniliRemove);
      persist();
    } else if (event.target.closest('[data-bynili-close]')) dialog.close();
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const rect=dialog.getBoundingClientRect(); if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom) dialog.close(); } });
  dialog.addEventListener('close', () => lastOpener?.focus());
  window.addEventListener('storage', event => { if (event.key === key) { load(); sync(); render(); } });
  new MutationObserver(records => { for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) { if (node.matches('[data-bynili-favorite]')) sync(node.parentElement); else sync(node); } }).observe(document.body, {childList:true,subtree:true});
  load();
  sync();
})();
